import React from "react";

export default function ML_Clustering() {
  return (
    <div>
      <h1>ML_Clustering</h1>
      <p>This is the ML_Clustering component.</p>
    </div>
  );
}
